module.exports = __webpack_public_path__ + "static/media/step1.34f3de46.png";